// extracted by mini-css-extract-plugin
export default {"label":"styles_label__lZrMT","iconColor":"styles_iconColor__nC6y4"};